<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M5 5h5v4H5V5zm6 4V5h10v14H11V9zm10 11H11v7h10v-7zm1 7v-7h5v7h-5zm0-8v-4h5v4h-5zm0-5h5v-4h-5v4zm0-5h5V5h-5v4zm-12 6v4H5v-4h5zm0-5v4H5v-4h5zm0 17v-7H5v7h5zM3 5a2 2 0 012-2h22a2 2 0 012 2v22a2 2 0 01-2 2H5a2 2 0 01-2-2V5zm15 5h-4v4h4v-4zm-4-1a1 1 0 00-1 1v5a1 1 0 001 1h4a1 1 0 001-1v-5a1 1 0 00-1-1h-4z"/></svg>